import { Chip, useTheme } from "@mui/material";
import useStyles from "./styles";

export default function TagCliente({ tag, compacto = false }) {
	const theme = useTheme();
	const styles = useStyles(theme, tag?.color);

	if (!tag) return null;
	return <Chip size="small" label={tag?.name} sx={compacto ? { ...styles.chip, ...styles.chipCompacto } : styles.chip} />;
}
